import {
  WaterItemWrapper,
  WaterItemLeft,
  WaterItemIconBox,
  WaterItemLabelBox,
  WaterItemValue,
  WaterItemUnit,
  WaterItemCountBadge,
  WaterItemCountNumber,
  WaterItemControls,
  ControlButtonWrapper,
  ControlButton,
} from "./styled"
import WaterBottleIcon from "./WaterBottleIcon"

interface WaterItemProps {
  amount: number
  unit: "ml" | "oz"
  count: number
  plusDisabled?: boolean
  onIncrement: () => void
  onDecrement: () => void
}

const MinusIcon = ({ disabled = false }: { disabled?: boolean }) =>
  disabled ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="2"
      viewBox="0 0 16 2"
      fill="none"
    >
      <rect width="16" height="2" rx="1" fill="#0DA3BA" fillOpacity="0.16" />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="2"
      viewBox="0 0 16 2"
      fill="none"
    >
      <rect width="16" height="2" rx="1" fill="#0DA3BA" />
    </svg>
  )

const PlusIcon = ({ disabled = false }: { disabled?: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M0 8C0 8.275 0.100156 8.5 0.300469 8.7C0.500782 8.9 0.726135 9 1.00156 9H7.01095V15C7.01095 15.25 7.11111 15.5 7.31142 15.7C7.51174 15.9 7.73709 16 8.01252 16C8.28795 16 8.5133 15.9 8.71362 15.7C8.91393 15.5 8.98905 15.275 8.98905 15V9H15.0235C15.2739 9 15.5243 8.9 15.6995 8.7C15.8998 8.5 16 8.275 16 8C16 7.725 15.8998 7.5 15.6995 7.3C15.4992 7.1 15.2739 7 15.0235 7H8.96401V1C8.96401 0.750001 8.86385 0.500001 8.68858 0.300001C8.48826 0.100001 8.26291 0 7.98748 0C7.71205 0 7.4867 0.100001 7.28639 0.300001C7.08607 0.500001 6.98592 0.725001 6.98592 1V7H0.976526C0.701095 7 0.475743 7.1 0.27543 7.3C0.100156 7.5 0 7.75 0 8Z"
      fill="#0DA3BA"
      fillOpacity={disabled ? 0.16 : 1}
    />
  </svg>
)

const XIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7"
    height="7"
    viewBox="0 0 7 7"
    fill="none"
  >
    <path
      d="M0.353516 6.35352L3.35352 3.35352M3.35352 3.35352L6.35352 0.353516M3.35352 3.35352L0.353516 0.353516M3.35352 3.35352L6.35352 6.35352"
      stroke="#1C1F21"
    />
  </svg>
)

const WaterItem = ({
  amount,
  unit,
  count,
  plusDisabled,
  onIncrement,
  onDecrement,
}: WaterItemProps) => {
  return (
    <WaterItemWrapper>
      <WaterItemLeft>
        <WaterItemIconBox $active={count > 0}>
          <WaterBottleIcon size={amount} unit={unit} />
        </WaterItemIconBox>
        <WaterItemLabelBox>
          <WaterItemValue>{amount}</WaterItemValue>
          <WaterItemUnit>{unit}</WaterItemUnit>
          {count > 0 && (
            <WaterItemCountBadge>
              <XIcon />
              <WaterItemCountNumber>{count}</WaterItemCountNumber>
            </WaterItemCountBadge>
          )}
        </WaterItemLabelBox>
      </WaterItemLeft>
      <WaterItemControls>
        <ControlButtonWrapper>
          <ControlButton
            $disabled={count === 0}
            onClick={onDecrement}
            disabled={count === 0}
          >
            <MinusIcon disabled={count === 0} />
          </ControlButton>
        </ControlButtonWrapper>
        <ControlButtonWrapper>
          <ControlButton
            $disabled={plusDisabled}
            onClick={onIncrement}
            disabled={plusDisabled}
          >
            <PlusIcon disabled={plusDisabled} />
          </ControlButton>
        </ControlButtonWrapper>
      </WaterItemControls>
    </WaterItemWrapper>
  )
}

export default WaterItem
